import React from 'react';
import { Link } from 'react-router-dom';

const FOOTER_LINKS: [string, string][] = [
  ['/home/roadmap', 'Roadmap'],
  ['/lab', 'The Lab'],
  ['/archive', 'Archive'],
  ['/wes-sandbox', "Wes's Sandbox"],
];

export const Footer: React.FC = () => {
  return (
    <footer className="mt-auto border-t border-[var(--p-hairline)] bg-[var(--p-paper)]">
      <div className="container mx-auto px-4 py-5">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <span className="font-body text-[13px] uppercase tracking-[0.22em] text-[var(--p-faint)]">
            Peak Priorities LLC&nbsp;&nbsp;|&nbsp;&nbsp;priorities.ai
          </span>
          <div className="flex items-center gap-2.5">
            {FOOTER_LINKS.map(([to, label]) => (
              <Link
                key={to}
                to={to}
                className="border border-[var(--p-hairline)] px-3 py-1.5 font-body text-[13px] uppercase tracking-[0.18em] text-[var(--p-label)] transition-colors hover:border-[var(--p-hairline-2)] hover:text-[var(--p-ink)]"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
